import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-result-dispatch',
  templateUrl: './result-dispatch.component.html',
  styleUrls: ['./result-dispatch.component.scss'],
})
export class ResultDispatchComponent implements OnInit {
  isLoading = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  samples: any = [];
  Success;
  billId;
  message;
  record: any = [];
  templates: any = [];
  startdate = '';
  enddate = '';
  is_dispatched_to_patient;
  is_dispatched_to_reception;
  result_id;
  dispatchPatientLoad: boolean = false;
  dispatchReceptionLoad: boolean = false;
  id: string = '';

  Template_Text = '';

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '300px',
    maxHeight: '300px',
    width: 'auto',
    minWidth: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat'],
    ],
  };

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl(''),
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('billId');
    console.log(this.id);
    this.sample.getResultsById(this.id).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.data.filter(
          (t) => t.department_name == 'LABORATORY' && t.is_finalized == 'Y'
        );
        this.isLoading = false;
        console.log(this.data);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  getResult() {
    this.sample.getResultsById(this.id).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.data.filter(
          (t) => t.department_name == 'LABORATORY' && t.is_finalized == 'Y'
        );
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getTemplate(result_id) {
    this.sample.getdetails(result_id).subscribe(
      (resSuccess) => {
        this.templates = resSuccess;
        this.Template_Text = this.templates.data;
        this.stateForm.patchValue({
          formatstr: this.templates.data,
        });
        console.log(this.templates.data);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  addRecord(item) {
    // this.stateForm.reset()
    this.record = item;
    this.mode = 'wiz';
    this.Errors = '';
    this.getTemplate(item.result_id);
    this.stateForm.patchValue({
      sample_id: item.sample_id,
      format_code: item.format_code,
      result_id: item.result_id,
    });
    this.is_dispatched_to_patient = item.is_dispatched_to_patient;
    this.is_dispatched_to_reception = item.is_dispatched_to_reception;
    this.result_id = item.result_id;
    console.log(this.record);
  }
  back() {
    this.mode = 'form';
  }
  done() {
    this.mode = 'form';
    // this.stateForm.patchValue({
    //   formatstr: this.Template_Text
    // });
    console.log(this.stateForm.value);
    this._snackBar.open('Template Added Successfully', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text.replace(/"/g, "'");
  }

  dispatchResultPatient() {
    this.dispatchPatientLoad = true;
    let is_dispatched_to_patient = 'Y';
    // is_dispatched_to_reception
    this.sample
      .dispatchResult(
        this.result_id,
        is_dispatched_to_patient,
        this.is_dispatched_to_reception
      )
      .subscribe(
        (resSuccess) => {
          this.dispatchPatientLoad = false;
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);

          if (this.message.success) {
            this._snackBar.open('Dispatched To Patient', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.getResult();
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
            this._snackBar.open('Error: please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this.Errors = resErr;
          this._snackBar.open('Error: try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }
  dispatchResultReception() {
    this.dispatchReceptionLoad = true;
    let is_dispatched_to_reception = 'Y';
    this.sample
      .dispatchResult(
        this.result_id,
        this.is_dispatched_to_patient,
        is_dispatched_to_reception
      )
      .subscribe(
        (resSuccess) => {
          this.dispatchReceptionLoad = false;
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);

          if (this.message.success) {
            this._snackBar.open('Dispatched To Reception', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.getResult();
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
            this._snackBar.open('Error: please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this.Errors = resErr;
          this._snackBar.open('Error: try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }
}
